import React from "react";
import ProductsPage from "../../features/products/products-page";
// import "../../styles/scss/products.scss";
export default function Products() {
  return <ProductsPage />;
}
